import script from "./courseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./courseDetail.vue?vue&type=script&setup=true&lang=js"

import "./courseDetail.vue?vue&type=style&index=0&id=0c80e498&lang=scss&scoped=true"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c80e498"]])

export default __exports__